import { MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import GradientBar from "../GradientBar";
import SoloIcon from "../SoloIcon";
import { useDashboardColor } from "../../context/DashboardColorContext";
import MetricBarChart from "../charts/MetricBarChart";
import MetricStatValue from "../charts/MetricStatValue";
import MetricCard from "../MetricCard";

const AccessibilityMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag }: MetricPanelProps) => {   
    const color = useDashboardColor();
          
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Accessibility data:", sortedMetrics);

    const a = sortedMetrics[0];
    const healthyFood = indicators.find((i: any) => i.id === 1117);
    const snap = indicators.find((i: any) => i.id === 1110);
    const freeReducedLunch = indicators.find((i: any) => i.id === 1118);
    const commute = indicators.find((i: any) => i.id === 1082);

    return (
        <div className="h-screen">
        <p className="text-xs text-neutral-600 mx-6 pt-2">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
        </p>
        <div className="mx-auto px-4 pb-8 pt-2">
            <div className="grid grid-cols-1 xxs:grid-cols-2 gap-4">
                <div className="col-span-1 xxs:col-span-2 w-full">
                    <div 
                        className="relative overflow-hidden group hover:shadow-md transition-all border rounded-xl bg-white" 
                    >
                        <div className="bg-white p-3">
                            <h3 className="text-sm font-semibold text-color-cai-brown">
                                Food Access & Assistance
                            </h3>
                            
                            <div className="grid grid-cols-3 gap-2">
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1117}
                                            id={1117}
                                            unit={healthyFood?.versions[0].unit}
                                            title={healthyFood?.name ?? "Access to Healthy Food"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={healthyFood}/>
                                </div>
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1110}
                                            id={1110}
                                            unit={snap?.versions[0].unit}
                                            title={snap?.name ?? "Accessing SNAP Benefits"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={snap}/>
                                </div> 
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1118}
                                            id={1118}
                                            unit={freeReducedLunch?.versions[0].unit}
                                            title={freeReducedLunch?.name ?? "Free or Reduced-Price Lunch Eligibility"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={freeReducedLunch}/>
                                </div>
                            </div>
                        </div>
                        <GradientBar color={color} />
                    </div>
                </div>

                {a.map((metric: any) => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        svg={getSvgrMap(metric.id)} 
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                    />
                ))}

                <div className="col-span-1 xxs:col-span-2 w-full">
                    {commute && 
                        <MetricBarChart 
                            metric={commute}
                            svg={null}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            height="h-40" 
                            background="bg-white"
                            barColor="#1a3a67"
                        />
                    }
                </div>
            </div>
        </div>
        </div>
    );
}

export default AccessibilityMetrics;